(function () {
  const DUAL_HANDLE = 'j-booster-2-level-2-ev-charger-portable-25ft';
  const NACS_HANDLE = 'booster-2-bundle-nacs-25ft';
  const KIT_HANDLES = [DUAL_HANDLE, NACS_HANDLE];

  function pathMatchesKit(pathOrUrl) {
    var s = String(pathOrUrl || '');
    for (var i = 0; i < KIT_HANDLES.length; i++) {
      if (s.indexOf(KIT_HANDLES[i]) !== -1) return true;
    }
    return false;
  }

  function boot() {
    /* B2B: Liquid omits the root; also skip if SparkLayer session class is present. */
    if (document.documentElement.classList.contains('jp-b2b-hide-retail')) return;
    const root = document.querySelector('[data-jp-post-atc-upsell]');
    if (!root || root.__jpUpsellBooted) return;
    root.__jpUpsellBooted = true;

    const dualVariantId = Number(root.getAttribute('data-jp-dual-variant-id'));
    const upsellKit = String(root.getAttribute('data-jp-upsell-kit') || '').trim() || 'unknown';
    const checks = Array.from(root.querySelectorAll('[data-jp-upsell-id]'));
    const productSku = String(root.getAttribute('data-jp-product-sku') || '').trim();
    const productHandle = String(root.getAttribute('data-jp-product-handle') || '').trim();
    const ADD_TIMEOUT_MS = 6000;

    /* GTM/GA4: jp_post_atc_shown | jp_post_atc_add | jp_post_atc_skip.
       Every key is always present (null when n/a) so GTM's merged data model
       never carries a stale accessory_sku / skip_method into a later event. */
    function trackPostAtc(eventName, extra) {
      var payload = Object.assign(
        {
          event: eventName,
          post_atc_kit: upsellKit,
          product_sku: productSku || null,
          product_handle: productHandle || null,
          product_variant_id: dualVariantId || null,
          accessory_sku: null,
          accessory_skus: null,
          accessory_variant_ids: null,
          accessory_count: 0,
          skip_method: null
        },
        extra || {}
      );
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(payload);
      } catch (e) { /* ignore */ }
      try {
        if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
          Shopify.analytics.publish(eventName, payload);
        }
      } catch (e2) { /* ignore */ }
    }

    /* Header badge from /cart.js, independent of section HTML so it can't stay stale. */
    function setBadgeCount(count) {
      var host = document.getElementById('cart-icon-bubble');
      if (!host) return;
      var bubble = host.querySelector('[data-cart-count-badge]') || host.querySelector('.cart-count-bubble');
      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        bubble.setAttribute('data-cart-count-badge', '');
        bubble.innerHTML = '<span aria-hidden="true" data-cart-count></span><span class="visually-hidden" data-cart-count-label></span>';
        host.appendChild(bubble);
      }
      var num = bubble.querySelector('[data-cart-count]') || bubble.querySelector('span[aria-hidden]');
      var label = bubble.querySelector('[data-cart-count-label]') || bubble.querySelector('.visually-hidden');
      if (count > 0) {
        bubble.classList.remove('cart-count-bubble--empty');
        if (num) num.textContent = count < 100 ? String(count) : '';
        if (label) label.textContent = count === 1 ? '1 item' : (count + ' items');
        bubble.hidden = false;
      } else {
        bubble.classList.add('cart-count-bubble--empty');
        if (num) num.textContent = '';
        if (label) label.textContent = '';
        bubble.hidden = true;
      }
    }

    function fetchCart() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.json(); });
    }

    function refreshBadge() {
      return fetchCart()
        .then(function (c) {
          if (c && typeof c.item_count === 'number') setBadgeCount(c.item_count);
          return c;
        })
        .catch(function () { /* ignore */ });
    }

    function trackUpsell(eventName, detail) {
      var payload = Object.assign(
        {
          event: eventName,
          kit: upsellKit,
          source: 'post_atc_interstitial'
        },
        detail || {}
      );
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(payload);
      } catch (e) { /* ignore */ }
      try {
        if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
          Shopify.analytics.publish(eventName, payload);
        }
      } catch (e2) { /* ignore */ }
    }
    const addBtn = root.querySelector('[data-jp-upsell-add]');
    const status = root.querySelector('[data-jp-upsell-status]');
    const declineBtns = Array.from(root.querySelectorAll('[data-jp-upsell-decline]'));
    const backdrop = root.querySelector('[data-jp-upsell-backdrop]');

    let pendingDual = null; // { key, variant_id, sections, response }
    let intercepting = false;
    let open = false;

    function selected() {
      return checks.filter(function (c) { return c.checked && !c.disabled; });
    }

    function syncAdd() {
      if (!addBtn) return;
      var n = selected().length;
      addBtn.disabled = n === 0 || intercepting;
      if (intercepting) return;
      if (n === 0) {
        addBtn.textContent = 'Add selected';
      } else if (n === 1) {
        addBtn.textContent = 'Add 1 accessory';
      } else {
        addBtn.textContent = 'Add ' + n + ' accessories';
      }
    }

    function cartEl() {
      return document.querySelector('cart-notification');
    }

    function sectionIds(cart) {
      if (!cart || typeof cart.getSectionsToRender !== 'function') return '';
      return cart.getSectionsToRender().map(function (part) { return part.id; }).join(',');
    }

    function silentUpdateSections(sections) {
      const cart = cartEl();
      if (!cart || !sections) return;
      ['cart-notification-button', 'cart-icon-bubble'].forEach(function (id) {
        const el = document.getElementById(id);
        if (!el || !sections[id]) return;
        try {
          const html = cart.getSectionInnerHTML(sections[id]);
          if (html != null) el.innerHTML = html;
        } catch (e) { /* ignore */ }
      });
    }

    function showConfirmation(parsedState) {
      const cart = cartEl();
      if (cart && parsedState && parsedState.sections && typeof cart.renderContents === 'function') {
        try {
          cart.renderContents(parsedState);
          return;
        } catch (e) {
          console.error(e);
        }
      }
      window.location.assign((window.routes && window.routes.cart_url) || '/cart');
    }

    function closeModal() {
      root.hidden = true;
      open = false;
      document.body.classList.remove('jp-post-atc-upsell-open');
      checks.forEach(function (c) { c.checked = false; });
      if (status) status.textContent = '';
      syncAdd();
    }

    function openModal(dualState) {
      pendingDual = dualState;
      silentUpdateSections(dualState && dualState.sections);
      root.hidden = false;
      open = true;
      document.body.classList.add('jp-post-atc-upsell-open');
      if (status) status.textContent = '';
      syncAdd();
      trackUpsell('jp_post_atc_interstitial_open', {
        primary_variant_id: dualState && (dualState.variant_id || dualVariantId)
      });
      trackPostAtc('jp_post_atc_shown');
      // Do not autofocus first card — orange :focus-within looked "selected"
      const panel = root.querySelector('.jp-post-atc-upsell__panel');
      if (panel) panel.focus({ preventScroll: true });
    }

    function isDualAdd(parsedState) {
      if (!parsedState) return false;
      const item =
        parsedState.items && parsedState.items.length
          ? parsedState.items[0]
          : parsedState;
      const vid = Number(
        parsedState.variant_id ||
          parsedState.id ||
          (item && (item.variant_id || item.id)) ||
          0
      );
      if (dualVariantId && vid === Number(dualVariantId)) return true;

      const productUrl = String(
        (item && (item.url || item.handle)) ||
          parsedState.url ||
          parsedState.handle ||
          ''
      );
      if (pathMatchesKit(productUrl)) return true;

      // Fallback: Dual/NACS PDP when ATC payload has no product url/handle
      const path = (window.location && window.location.pathname) || '';
      if (!productUrl && pathMatchesKit(path)) {
        if (vid && dualVariantId && vid !== Number(dualVariantId)) return false;
        return true;
      }
      return false;
    }

    function normalizeDualState(parsedState) {
      // product-form single-add response is the line item; sticky may wrap items[0]
      const item =
        parsedState.items && parsedState.items.length
          ? parsedState.items[0]
          : parsedState;
      return {
        key: item.key || parsedState.key,
        variant_id: item.variant_id || item.id || parsedState.variant_id || dualVariantId,
        sections: parsedState.sections,
        response: parsedState,
        item: item
      };
    }

    function decline(method) {
      if (intercepting || !open) return;
      const dual = pendingDual;
      trackUpsell('jp_post_atc_interstitial_decline', {
        primary_variant_id: dual && (dual.variant_id || dualVariantId)
      });
      trackPostAtc('jp_post_atc_skip', { skip_method: typeof method === 'string' ? method : 'unknown' });
      closeModal();
      refreshBadge();
      if (!dual) return;
      const justAddedKeys = dual.key ? [dual.key] : [];
      const renderData = Object.assign({}, dual.item || {}, {
        key: dual.key,
        sections: dual.sections,
        justAddedKeys: justAddedKeys.length ? justAddedKeys : undefined
      });
      pendingDual = null;
      // cartUpdate backup often opens modal without section HTML — fetch then toast
      if (!dual.sections || !dual.sections['cart-notification-product']) {
        fetchJustAddedAndNotify(justAddedKeys, renderData);
        return;
      }
      showConfirmation(renderData);
    }

    function addSelected() {
      const picked = selected();
      if (!picked.length || !addBtn || addBtn.disabled || intercepting) return;

      const cart = cartEl();
      const dualKey = pendingDual && pendingDual.key;
      const payload = {
        items: picked.map(function (c) {
          return {
            id: Number(c.value),
            quantity: 1,
            properties: {
              _source: 'post_atc_interstitial',
              _kit: upsellKit
            }
          };
        })
      };

      if (cart && typeof cart.getSectionsToRender === 'function') {
        payload.sections = sectionIds(cart);
        payload.sections_url = window.location.pathname;
        cart.setActiveElement(addBtn);
      }

      intercepting = true;
      addBtn.disabled = true;
      addBtn.setAttribute('aria-busy', 'true');
      if (status) status.textContent = 'Adding…';

      const pickedIds = picked.map(function (c) { return Number(c.value); });
      const pickedSkus = picked.map(function (c) { return c.getAttribute('data-jp-upsell-sku') || ''; });
      const controller = typeof AbortController === 'function' ? new AbortController() : null;
      const abortTimer = controller ? setTimeout(function () { controller.abort(); }, ADD_TIMEOUT_MS) : null;

      function addedEvent() {
        trackPostAtc('jp_post_atc_add', {
          accessory_sku: pickedSkus.filter(Boolean).join(',') || null,
          accessory_skus: pickedSkus,
          accessory_variant_ids: pickedIds,
          accessory_count: picked.length
        });
      }

      fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
        signal: controller ? controller.signal : undefined,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok || data.status) {
              throw new Error(data.description || data.message || 'Unable to add accessories.');
            }
            return data;
          });
        })
        .then(function (data) {
          if (abortTimer) clearTimeout(abortTimer);
          trackUpsell('jp_post_atc_interstitial_add', {
            primary_variant_id: dualVariantId,
            accessory_variant_ids: picked.map(function (c) { return Number(c.value); }),
            accessory_count: picked.length
          });
          addedEvent();
          const accessoryKeys = (data.items || []).map(function (i) { return i.key; }).filter(Boolean);
          const justAddedKeys = [];
          if (dualKey) justAddedKeys.push(dualKey);
          accessoryKeys.forEach(function (k) {
            if (justAddedKeys.indexOf(k) === -1) justAddedKeys.push(k);
          });

          // Prefer sections from accessory add (includes Dual + accessories in cart)
          const sections = data.sections || (pendingDual && pendingDual.sections);
          const first = (data.items && data.items[0]) || {};

          closeModal();
          pendingDual = null;
          refreshBadge();

          const renderData = Object.assign({}, first, {
            key: first.key || dualKey,
            sections: sections,
            items: data.items,
            justAddedKeys: justAddedKeys
          });

          // If section HTML is missing Dual (edge), fetch cart.js + section to rebuild
          if (!sections || !sections['cart-notification-product']) {
            return fetchJustAddedAndNotify(justAddedKeys, renderData);
          }
          showConfirmation(renderData);
        })
        .catch(function (err) {
          if (abortTimer) clearTimeout(abortTimer);
          /* Slow/aborted response: the add may still have landed. Check the cart
             before showing an error so the popup never hangs on "Adding...". */
          return fetchCart()
            .then(function (c) {
              var inCart = (c && c.items || []).map(function (i) { return Number(i.variant_id); });
              var allIn = pickedIds.every(function (id) { return inCart.indexOf(id) !== -1; });
              if (!allIn) throw err;
              addedEvent();
              closeModal();
              pendingDual = null;
              if (c && typeof c.item_count === 'number') setBadgeCount(c.item_count);
              var keys = [];
              if (dualKey) keys.push(dualKey);
              (c.items || []).forEach(function (i) {
                if (pickedIds.indexOf(Number(i.variant_id)) !== -1 && keys.indexOf(i.key) === -1) keys.push(i.key);
              });
              return fetchJustAddedAndNotify(keys, { key: keys[0], justAddedKeys: keys });
            })
            .catch(function () {
              if (status) {
                status.textContent = (err && err.name === 'AbortError')
                  ? 'Unable to add accessories.'
                  : ((err && err.message) || 'Unable to add accessories.');
              }
            });
        })
        .finally(function () {
          intercepting = false;
          addBtn.removeAttribute('aria-busy');
          syncAdd();
        });
    }

    function fetchJustAddedAndNotify(justAddedKeys, fallback) {
      const cart = cartEl();
      if (!cart) {
        window.location.assign((window.routes && window.routes.cart_url) || '/cart');
        return;
      }
      const ids = sectionIds(cart);
      const url = '/?sections=' + encodeURIComponent(ids);
      return fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          const firstKey = justAddedKeys[0];
          showConfirmation({
            key: firstKey,
            sections: sections,
            justAddedKeys: justAddedKeys
          });
        })
        .catch(function () {
          showConfirmation(fallback);
        });
    }

    checks.forEach(function (c) { c.addEventListener('change', syncAdd); });
    if (addBtn) addBtn.addEventListener('click', addSelected);
    declineBtns.forEach(function (btn) {
      var method = btn.classList.contains('jp-post-atc-upsell__close') ? 'close_button' : 'continue_without';
      btn.addEventListener('click', function () { decline(method); });
    });
    if (backdrop) backdrop.addEventListener('click', function () { decline('backdrop'); });

    document.addEventListener('keydown', function (evt) {
      if (!open) return;
      if (evt.key === 'Escape') {
        evt.preventDefault();
        decline('escape');
      }
    });

    // Intercept Dual cart-notification opens from product-form + sticky ATC
    function installIntercept() {
      const cart = cartEl();
      if (!cart || typeof cart.renderContents !== 'function') return false;
      if (cart.__jpUpsellPatched) return true;
      cart.__jpUpsellPatched = true;
      const orig = cart.renderContents.bind(cart);
      cart.renderContents = function (parsedState) {
        // Allow multi-line / confirmation paths through when flagged
        if (parsedState && parsedState.justAddedKeys) {
          return orig(parsedState);
        }
        // Dual primary ATC (product-form or sticky): open interstitial, defer toast
        if (!intercepting && parsedState && isDualAdd(parsedState)) {
          if (!open) {
            openModal(normalizeDualState(parsedState));
          }
          return;
        }
        // Modal already open / pending Dual — don't toast yet, but keep sections/key
        if ((open || pendingDual) && parsedState && isDualAdd(parsedState)) {
          if (pendingDual) {
            var merged = normalizeDualState(parsedState);
            if (merged.sections) pendingDual.sections = merged.sections;
            if (merged.key) pendingDual.key = pendingDual.key || merged.key;
            if (merged.item) pendingDual.item = pendingDual.item || merged.item;
          }
          return;
        }
        return orig(parsedState);
      };
      return true;
    }

    function ensureIntercept() {
      if (installIntercept()) return;

      function onReady() {
        installIntercept();
      }
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', onReady, { once: true });
      } else {
        onReady();
      }

      // Short retries until cart-notification exists and is patched
      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        if (installIntercept() || tries >= 10) {
          clearInterval(timer);
        }
      }, 100);

      // Watch for cart-notification mounting late
      if (typeof MutationObserver === 'function') {
        var observer = new MutationObserver(function () {
          if (installIntercept()) {
            observer.disconnect();
          }
        });
        observer.observe(document.documentElement, { childList: true, subtree: true });
        setTimeout(function () {
          try { observer.disconnect(); } catch (e) { /* ignore */ }
        }, 8000);
      }
    }

    ensureIntercept();

    // Backup: open modal on cartUpdate (product-form) if Dual — still defer toast via renderContents patch
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (!event || !event.cartData) return;
        if (open || intercepting || pendingDual) return;
        if (event.source && event.source !== 'product-form' && event.source !== 'jp-sticky-atc') return;
        var data = event.cartData;
        // productVariantId from form is also a Dual signal
        var formVid = event.productVariantId != null ? Number(event.productVariantId) : 0;
        var dualByForm = dualVariantId && formVid === Number(dualVariantId);
        if (!isDualAdd(data) && !dualByForm) return;
        installIntercept();
        openModal(normalizeDualState(data));
      });
    }

    syncAdd();

    window.jpPostAtcUpsell = {
      open: openModal,
      isDualAdd: isDualAdd,
      installIntercept: installIntercept
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
